import React from 'react';
import { IProductModuleProps } from '../../../interfaces/interfaces';

function ProductModulePreview(props: IProductModuleProps): JSX.Element {
  const { creditId, creditType } = props;

  return (
    <div className="preview">
      <h5 className="hl-2 bold font-color-blue">{creditId}</h5>
      {creditType && <p className="tx_1">{creditType}</p>}
    </div>
  );
}
export default ProductModulePreview;
